/** Write a GLB 2.0 container using browser-native binary APIs. */
export const writeGlbBinary = (gltf: unknown, binary: Uint8Array): ArrayBuffer => {
    const json = new TextEncoder().encode(JSON.stringify(gltf));
    const jsonLength = Math.ceil(json.byteLength / 4) * 4;
    const binaryLength = Math.ceil(binary.byteLength / 4) * 4;
    const buffer = new ArrayBuffer(12 + 8 + jsonLength + 8 + binaryLength);
    const bytes = new Uint8Array(buffer);
    const header = new DataView(buffer);

    header.setUint32(0, 0x46546c67, true); // glTF
    header.setUint32(4, 2, true);
    header.setUint32(8, buffer.byteLength, true);
    header.setUint32(12, jsonLength, true);
    header.setUint32(16, 0x4e4f534a, true); // JSON
    bytes.fill(0x20, 20, 20 + jsonLength);
    bytes.set(json, 20);

    const binaryHeaderOffset = 20 + jsonLength;
    header.setUint32(binaryHeaderOffset, binaryLength, true);
    header.setUint32(binaryHeaderOffset + 4, 0x004e4942, true); // BIN
    bytes.set(binary, binaryHeaderOffset + 8);
    return buffer;
};
